export const DEPOSIT_AMOUNT      = 20;
export const CANCEL_POLICY_HOURS = 48;
export const MAX_PHOTOS          = 5;
export const PHOTO_BUCKET        = 'booking-photos';
